import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "We've sent an email to you. You should be receiving it shortly.", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " If you don't receive the email, please make sure you've entered the correct email address, and check your spam folder. ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Forgot your password? Enter your email address below and we'll email you instructions for resetting your password. ")
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email address", -1)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Submitting ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Submit")

import api from "@virgodev/bazaar/functions/api";
import { nextTick, ref, watch } from "vue";
import scrollToFirstError from "@/methods/scroll_to_first_error";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const formFields = ref({
  email: "",
});

const formErrors = ref<Record<string, string[]>>({});
watch(formErrors, () => {
  if (formErrors.value.non_field_errors !== undefined) {
    nextTick(scrollToFirstError);
  }
});

const formSubmitting = ref(false);
const formSuccess = ref(false);

async function submitForm() {
  formErrors.value = {};
  formSubmitting.value = true;

  const responseData = await api({
    url: "users/password_reset/",
    method: "POST",
    json: formFields.value,
  });

  formSubmitting.value = false;

  if (responseData.status === 200) {
    formSuccess.value = true;
    window.scrollTo(0, 0);
  } else if (responseData.status === 400) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your connection " +
          "and try again.",
      ],
    };
  }
}

return (_ctx: any,_cache: any) => {
  const _component_BaseAlert = _resolveComponent("BaseAlert")!
  const _component_TransitionSlide = _resolveComponent("TransitionSlide")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!

  return (formSuccess.value)
    ? (_openBlock(), _createBlock(_component_BaseAlert, {
        key: 0,
        variant: "success"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_BaseAlert, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_TransitionSlide, { mode: "out-in" }, {
          default: _withCtx(() => [
            (formErrors.value.non_field_errors !== undefined)
              ? (_openBlock(), _createBlock(_component_BaseAlert, {
                  key: 0,
                  variant: "danger",
                  class: "js-form-error",
                  dismissible: "",
                  onDismissed: _cache[0] || (_cache[0] = ($event: any) => (formErrors.value = {}))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("form", {
          class: "well",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              id: "email",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.email) = $event)),
              type: "email",
              required: ""
            }, null, 512), [
              [_vModelText, formFields.value.email]
            ])
          ]),
          _createElementVNode("button", {
            type: "submit",
            disabled: formSubmitting.value,
            class: "btn btn-text"
          }, [
            (formSubmitting.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_8,
                  _createVNode(_component_BaseSpinner)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_9
                ], 64))
          ], 8, _hoisted_7)
        ], 40, _hoisted_4)
      ], 64))
}
}

})